export default __webpack_public_path__ + "static/media/dashboard-icon.dc9c9d9c.svg";